import { render, staticRenderFns } from "./CertSection.vue?vue&type=template&id=1960b280&scoped=true"
import script from "./CertSection.vue?vue&type=script&lang=js"
export * from "./CertSection.vue?vue&type=script&lang=js"
import style0 from "./CertSection.vue?vue&type=style&index=0&id=1960b280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960b280",
  null
  
)

export default component.exports